import { useEffect, useState }            from 'react'
import { useProjectSetup }      from 'hooks/useProjectSetup'
import { useFetch_Bootstrap }   from 'hooks/fetch/useFetch_Bootstrap'
import { useFetch_Colors }      from 'hooks/fetch/useFetch_Colors'
import { useFetch_Navigation }  from 'hooks/fetch/useFetch_Navigation'
import { useFetch_Highlights }  from 'hooks/fetch/useFetch_Highlights'
import { usePreload_Logos }     from 'hooks/preload/usePreload_Logos'
import { useSetAtom }        from 'state/jotai'
import { renderLayout }         from 'state/store.global'
import { _bootstrap }           from 'state/store.bootstrap'

export const Boot = () => {

  const setRenderLayout = useSetAtom(renderLayout)
  const [deferredLoaded, setDeferredLoaded] = useState(false)

  // Critical path - load immediately
  const bootstrap = useFetch_Bootstrap()
  const colors = useFetch_Colors().res
  const navigation = useFetch_Navigation().res

  // Secondary path - defer to idle time  
  const highlights = useFetch_Highlights().res
  const logos = usePreload_Logos().res
  const projectSetup = useProjectSetup().res

  const criticalReady = bootstrap && colors && navigation
  const allReady = criticalReady && highlights && logos && projectSetup
  
  useEffect( ()=> {
    if ( criticalReady ) {
      setRenderLayout(true)
    }
  }, [criticalReady, setRenderLayout])

  // Defer non-critical tasks
  useEffect(() => {
    if (criticalReady && !deferredLoaded) {
      // Use requestIdleCallback to split work
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          setDeferredLoaded(true)
        }, { timeout: 3000 })
      } else {
        setTimeout(() => setDeferredLoaded(true), 100)
      }
    }
  }, [criticalReady, deferredLoaded])

  return

}

// Boot.whyDidYouRender = true
